import { TRANSACTION_TYPES } from '../utils/constants';

const addonsRoutes = [

    {
        path: '/addons',
        name: 'AddonsPage',
        component: () => import('../views/addons/AddonsComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'addons',
        },
    },

    {
        path: '/addons/create',
        name: 'AddonsCreatePage',
        component: () => import('../views/addons/AddonsManagerComponent.vue'),
        props: { type: TRANSACTION_TYPES.CREATE },
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'addons',
        },
    },

    {
        path: '/addons/edit/:addonId',
        name: 'AddonsEditPage',
        component: () => import('../views/addons/AddonsManagerComponent.vue'),
        props: (route) => ({ type: TRANSACTION_TYPES.EDIT, addonId: route.params.addonId }),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'addons',
        },
    },

    {
        path: '/addons/show/:addonId',
        name: 'AddonsShowPage',
        component: () => import('../views/addons/AddonsManagerComponent.vue'),
        props: (route) => ({ type: TRANSACTION_TYPES.SHOW, addonId: route.params.addonId }),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'addons',
        },
    },

];

export default addonsRoutes;
